import configureStore from '../configureStore'
import convertStyleWithMultiplier from './styleHelper'

export const colors = {
  actionBlue: '#007DB3',
  action_blue30: '#007DB330',
  barBlue: 'rgb(116,181,211)',
  black: '#000',
  blue: '#3498db',
  brickGray: '#5a5a5a',
  bscBlue: '#003C71',
  charcoal: '#242526',
  darkGray: '#808080',
  eolRed: '#C60F13',
  eriYellow: '#FBAC32',
  error_red: '#CC0000',
  inner_blue: '#4DA4C9',
  learnMoreBlue: '#48B8D2',
  learnMore_grey: '#7D868E',
  lightBlue: '#E5ECF2',
  lightBscBlue: '#648fb4',
  lightGray: '#EDEDED',
  navDrawerBackground: '#f6f6f6',
  okGreen: '#5DA423',
  raven_grey: '#6A737B',
  raven_grey10: '#F0F1F1',
  raven_grey20: '#E1E3E5',
  raven_grey50: '#B4B9Bd',
  raven_grey70: '#888E95',
  shark_grey: '#383838',
  shark_grey50: '#989898',
  white: '#ffffff',
  arrowBlue: 'rgb(15,124,194)',
  highlightBlue: 'rgb(195,227,243)',
  arrowGreen: 'rgb(102,175,4)',
  highlightGreen: 'rgb(205,231,163)',
  backgroundGray: '#F7F8F8',
  neutral_40: '#666666',
}

const styles = {
  aboutThisAppContentTextNoMargin: {
    color: colors.shark_grey,
    fontSize: 16,
    fontWeight: 'bold',
    marginTop: 20,
  },
  actionBlueLink: {
    color: colors.actionBlue,
    flexShrink: 1,
    fontSize: 16,
    fontWeight: '500',
    marginLeft: 5,
    paddingBottom: 10,
  },
  arrowButton: {
    alignItems: 'center',
    flex: 1,
    flexDirection: 'row',
    paddingHorizontal: 20,
  },
  bottomBorder: {
    borderBottomColor: colors.raven_grey50,
    borderBottomWidth: 1,
  },
  brickBody: {
    fontSize: 18,
    lineHeight: 24.66,
  },
  brickHead: {
    fontSize: 22,
    lineHeight: 30.14,
  },
  brickTop: { paddingTop: 75 },
  bulletText: {
    flex: 1,
    paddingLeft: 10,
  },
  centerPad: {
    paddingLeft: 40,
    paddingRight: 40,
  },
  colorIndicatorContainer: {
    alignContent: 'center',
    justifyContent: 'center',
    paddingLeft: 20,
  },
  connectionsMainView: {
    backgroundColor: colors.raven_grey10,
    flex: 1,
    flexGrow: 1,
    paddingBottom: 25,
    paddingTop: 7,
  },
  container: {
    alignItems: 'stretch',
    flex: 1,
    justifyContent: 'flex-start',
  },
  communicatorSetupButtonText: {
    color: colors.shark_grey,
    fontSize: 18,
    marginRight: 10,
  },
  communicatorSetupButtonTextView: {
    flex: 1,
  },
  detailColumn: {
    alignItems: 'flex-start',
    flexDirection: 'column',
  },
  detailRow: {
    alignItems: 'flex-start',
    flex: 1,
    flexDirection: 'row',
    flexWrap: 'wrap',
  },
  deviceInfoInput: {
    paddingBottom: 10,
    paddingLeft: 15,
    paddingRight: 15,
  },
  deviceInfoNote: {
    borderTopLeftRadius: 5,
    borderTopRightRadius: 5,
    color: colors.raven_grey70,
    margin: 15,
  },
  deviceModelInfoBody: {
    color: colors.darkGray,
    fontSize: 18,
    paddingTop: 5,
  },
  deviceModelInfoContainer: {
    paddingBottom: 10,
    paddingLeft: 15,
    paddingTop: 15,
  },
  deviceModelInfoHeader: {
    color: colors.darkGray,
    fontSize: 12,
    fontWeight: 'bold',
    lineHeight: 12,
  },
  euIdInfo: {
    color: colors.shark_grey,
    fontSize: 12,
  },
  faqContentContainer: {
    backgroundColor: colors.white,
    borderWidth: 0,
    flex: 1,
  },
  faqHelpfulText: {
    color: colors.raven_grey70,
    marginTop: 15,
  },
  faqHelpfulTextContainer: {
    alignItems: 'center',
    borderTopColor: colors.raven_grey70,
    borderTopWidth: 1,
    marginBottom: 15,
    marginTop: 15,
    width: '100%',
  },
  footer: {
    backgroundColor: colors.white,
    flexDirection: 'row',
    flexShrink: 1,
    justifyContent: 'center',
  },
  globalNumbersDialogContent: {
    maxHeight: 400,
  },
  globalNumbersDialogText: {
    color: colors.shark_grey,
    fontSize: 16,
    lineHeight: 22,
    marginBottom: 16,
  },
  globalNumbersScrollGradient: {
    position: 'absolute',
    bottom: 55,
    width: '100%',
    height: 75,
  },
  hyperlink: { color: colors.actionBlue },
  linkText: {
    fontSize: 16,
    lineHeight: 24,
  },
  iconWithTextContentText: {
    color: colors.shark_grey,
    flex: 1,
    fontSize: 16,
    lineHeight: 22,
    paddingLeft: 15,
  },
  iconWithTextView: {
    alignItems: 'center',
    flexDirection: 'row',
    justifyContent: 'space-between',
    paddingLeft: 10,
  },
  idCardShadow: {
    shadowColor: colors.black,
    shadowOffset: {
      height: 1,
      width: 1,
    },
    shadowOpacity: 0.8,
    shadowRadius: 2,
  },
  learnMoreContainer: {
    backgroundColor: colors.white,
    flex: 1,
    marginBottom: 0,
  },
  learnMoreHeader: {
    color: colors.shark_grey,
    fontSize: 16,
    fontWeight: 'bold',
    marginTop: 3,
    paddingBottom: 15,
    paddingLeft: 21,
    paddingRight: 10,
    paddingTop: 12,
  },
  learnMoreView: {
    alignItems: 'center',
    flexDirection: 'row',
    justifyContent: 'flex-start',
  },
  legalBodyContentText: {
    color: colors.shark_grey,
    fontSize: 16,
    lineHeight: 22,
    marginBottom: 16,
  },
  legalParagraphTitle: {
    fontWeight: 'bold',
    marginBottom: 0,
    paddingTop: 10,
  },
  lightsDescriptionText: {
    color: colors.shark_grey,
    fontSize: 14,
    fontWeight: 'bold',
  },
  lightSeparator: {
    borderBottomColor: colors.raven_grey20,
    borderBottomWidth: 1,
    marginHorizontal: 16,
  },
  lightStageContainer: {
    backgroundColor: colors.white,
    borderWidth: 0,
    flex: 1,
    padding: 15,
    paddingTop: 30,
  },
  lightStageDetailsHeading: {
    color: colors.shark_grey,
    fontSize: 16,
    fontWeight: '700',
  },
  lightStageHeader: {
    fontSize: 24,
    fontWeight: 'bold',
    color: colors.shark_grey,
    paddingBottom: 15,
  },
  loadingContainer: {
    alignItems: 'center',
    backgroundColor: colors.bscBlue,
    flex: 1,
    justifyContent: 'center',
  },
  logo: {
    marginBottom: 10,
    width: 281.25,
  },
  marginBottom16: { marginBottom: 16 },
  monitorHeading: {
    color: colors.shark_grey,
    fontSize: 17,
    fontWeight: 'bold',
  },
  monitorStatusLearnMoreText: {
    color: colors.raven_grey,
    fontWeight: '800',
  },
  moreInformationCell: {
    marginTop: 10,
    paddingLeft: 16,
    paddingRight: 16,
  },
  moreSection: {
    backgroundColor: colors.white,
    marginVertical: 24,
  },
  needHelpContainer: { paddingHorizontal: 10 },
  nextFooterContainerStyle: {
    marginBottom: 24,
    marginLeft: 24,
    marginRight: 24,
    marginTop: 8,
  },
  nextFooterGradientStyle: {
    bottom: 5,
    height: 5,
    width: '110%',
  },
  onBoardingBottomButtonContainer: {
    flexDirection: 'row',
    flexShrink: 1,
    justifyContent: 'flex-end',
    maxHeight: 59,
    minHeight: 59,
    paddingBottom: 10,
    paddingTop: 8,
  },
  onBoardingBottomButtonLeft: {
    alignItems: 'center',
    flex: 1,
    justifyContent: 'center',
    marginBottom: 5,
    marginLeft: 10,
    marginRight: 5,
    minHeight: 44,
  },
  onBoardingBottomButtonRight: {
    alignItems: 'center',
    flex: 1,
    justifyContent: 'center',
    marginBottom: 5,
    marginLeft: 5,
    marginRight: 10,
    minHeight: 44,
  },
  padding15: { padding: 15 },
  pdf: {
    flex: 1,
    height: 812,
    width: 375,
  },
  scrollGradient: {
    bottom: 55,
    height: 30,
    position: 'absolute',
    width: '100%',
  },
  separator: {
    borderBottomColor: colors.raven_grey70,
    borderBottomWidth: 1,
  },
  setupDynamicIllustration: {
    flex: 1,
    marginLeft: 20,
    marginRight: 20,
  },
  setupIllustration: {
    alignSelf: 'center',
    flex: 1,
  },
  setupStepNumber: {
    alignSelf: 'flex-start',
    flex: 1,
    marginTop: 10,
  },
  shadow: {
    borderRadius: 4,
    borderWidth: 0,
    marginBottom: 2,
    paddingBottom: 2,
    shadowColor: 'rgba(0,0,0,1)',
    shadowOffset: {
      height: 2,
      width: 2,
    },
    shadowOpacity: 1,
    shadowRadius: 1,
  },
  shark_grey: { color: colors.shark_grey },
  statusBodyText: {
    color: colors.shark_grey,
    fontSize: 16,
  },
  stepDescriptionStyle: {
    color: colors.white,
    fontSize: 24,
    fontWeight: '700',
  },
  stepNumberTextStyle: {
    color: colors.white,
    fontSize: 16,
    fontWeight: '700',
  },
  stepsContainer: {
    elevation: 0,
    flexShrink: 1,
    padding: 16,
  },
  tabBarHighlight: {
    backgroundColor: colors.white,
    flex: 1,
    maxHeight: 10,
    minHeight: 10,
    minWidth: '100%',
  },
  tabBarHighlightFocused: {
    backgroundColor: colors.bscBlue,
    flex: 1,
    maxHeight: 10,
    minHeight: 10,
    minWidth: '100%',
  },
  tableText: {
    color: colors.shark_grey,
    fontSize: 16,
  },
  termBody: {
    paddingLeft: 15,
    paddingRight: 15,
  },
  termsAndConditions: {
    paddingLeft: 15,
    paddingRight: 15,
    paddingTop: 15,
  },
  testBorder: {
    borderColor: colors.okGreen,
    borderWidth: 2,
  },
  textMargin: { marginBottom: 20 },
  tncBottomButtonContainer: {
    flexDirection: 'row',
    flexShrink: 1,
    justifyContent: 'flex-end',
    marginTop: 20,
    paddingBottom: 15,
  },
  tncBottomContainer: {
    backgroundColor: colors.actionBlue,
    paddingBottom: 10,
  },
  tncBottomTextContainer: {
    marginLeft: 16,
    marginRight: 16,
    marginTop: 25,
  },
  topPad: { paddingTop: 15 },
  warningCell: {
    alignItems: 'flex-start',
    flexDirection: 'row',
    paddingBottom: 16,
    paddingLeft: 16,
    paddingRight: 16,
    paddingTop: 15,
  },
  warningCellText: {
    color: colors.lightBlue,
    flex: 1,
    fontSize: 14,
    lineHeight: 18,
  },
  white: { color: colors.white },
  whiteBackground: { backgroundColor: colors.white },
  width10: { width: 10 },
  blueButton: {
    alignItems: 'center',
    borderRadius: 3,
    flex: 1,
    justifyContent: 'center',
    marginBottom: 8,
    minHeight: 40,
    backgroundColor: colors.bscBlue,
  },
  versionText: {
    color: colors.neutral_40,
    fontSize: 14,
  },
}

const Sheet = () => {
  const { storedData } = configureStore.getState()
  const { fontMultiplier } = storedData
  return convertStyleWithMultiplier(fontMultiplier || 1, styles)
}

export default Sheet()
